import {ApiError} from '../platform/api-error'
import {AddIssueFieldsDialogBannerResources} from '../strings'

export const MAX_FIELDS_PER_IMPORT = 15
export const MAX_FIELDS_PER_PROJECT = 50

export const ValidationResult = {
  FieldLimitReached: 'FieldLimitReached',
  WouldExceedProjectLimit: 'WouldExceedProjectLimit',
  ExceedsImportLimit: 'ExceedsImportLimit',
  NoFieldsSelected: 'NoFieldsSelected',
  Valid: 'Valid',
} as const

export type ValidationResult = ObjectValues<typeof ValidationResult>

export function getValidationResult(selectedCount: number, projectFieldCount: number): ValidationResult {
  if (projectFieldCount >= MAX_FIELDS_PER_PROJECT) {
    return ValidationResult.FieldLimitReached
  }
  if (selectedCount === 0) {
    return ValidationResult.NoFieldsSelected
  }
  if (projectFieldCount + selectedCount > MAX_FIELDS_PER_PROJECT) {
    return ValidationResult.WouldExceedProjectLimit
  }
  if (selectedCount > MAX_FIELDS_PER_IMPORT) {
    return ValidationResult.ExceedsImportLimit
  }
  return ValidationResult.Valid
}

export function isServerFieldLimitError(error: ApiError): boolean {
  return error.message.includes(AddIssueFieldsDialogBannerResources.serverErrorPatterns.fieldLimitReached)
}
